import { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Badge, TabsContainer } from '@frontierag/frontier-ui-library';
import { useField } from 'formik';

import AddProduct from './AddProduct';
import ViewBasket from './ViewBasket';

export default function OrderProducts() {
  const { t } = useTranslation('CreateCropOrder');

  const tabsRef = useRef<HTMLDivElement>(null);

  const [{ value: products = [] }] = useField('products');
  const productsCount = products.length;

  const viewBasketLabel = useMemo(() => {
    const tabLabel = <>{t('tabs.viewBasket')}</>;

    return productsCount > 0 ? (
      <Box alignItems="center" display="flex">
        {tabLabel}
        <Badge
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          badgeContent={productsCount}
          color="error"
          data-testid="view-basket-badge"
          sx={{ pl: 1, '& .MuiBadge-badge': { position: 'relative', transform: 'none' } }}
        />
      </Box>
    ) : (
      tabLabel
    );
  }, [productsCount, t]);

  return (
    <Box ref={tabsRef}>
      <TabsContainer sx={{ pb: 5 }}>
        <TabsContainer.Panel name="add-product" label={t('tabs.addProduct')} key={0}>
          <AddProduct />
        </TabsContainer.Panel>
        <TabsContainer.Panel name="view-basket" key={1} label={viewBasketLabel}>
          <ViewBasket />
        </TabsContainer.Panel>
      </TabsContainer>
    </Box>
  );
}
